import { Tabs } from "@shopify/polaris";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import Dashboard from "./dashboard";
import EmailMarketing from "./emailMarketing";
import Piexl from "./Piexl";
import Settings from "./Settings";
import Upsell from "./Upsell";
import PaymentIntegration from "./PaymentIntegration";
import { useState, useCallback } from "react";

export default function Home() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(0);
  const tabs = [
    {
      id: "index",
      content: "DashBoard",
    },
    {
      id: "settings",
      content: "Checkout Settings",
    },
    {
      id: "upsell",
      content: "Upsell",
    },
    {
      id: "piexl",
      content: "Piexl",
    },
  ];

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );
  const handleRoute = (value, i) => {
    navigate("/" + tabs[value].id);
    handleTabChange(value);
  };

  return (
    <Tabs
      tabs={tabs}
      selected={selected}
      onSelect={(value) => handleRoute(value)}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/index" replace />} />
        <Route path="/index" element={<Dashboard />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/upsell" element={<Upsell />} />
        <Route path="/piexl" element={<Piexl />} />
      </Routes>
    </Tabs>
  );
}
